import BaseProduct from '@views/dashboard/production/OrderProductPage';
import cacheableAccessor from '@src/helpers/cacheableAccessor';
import ProductionDashboard from '@views/dashboard/ProductionDashboard';
import getUri from '@src/helpers/getUri';
import {EndpointUri} from '@src/@types/EndpointUri';

const getPageBreadcrumbs = cacheableAccessor(() => [
    {
        label: ProductionDashboard.pageTitle,
        uri: getUri('dashboards@manager'),
    },
    {
        label: OrderProductPage.pageTitle,
        uri: {route: 'dashboards@manager-order-product-page'} as EndpointUri,
    }
]);

export default class OrderProductPage extends BaseProduct {
    protected getPageBreadcrumbs() {
        return getPageBreadcrumbs();
    }
}
